import React from 'react';

// redux

import { userInfoSelector } from "../../../../redux/selectors/auth";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import CustomToolbar from "../../../global/CustomToolbar";

import './LizAccounting.css'

import { ReactComponent as DeliveryIcon } from '../../../assets/delivery.svg';

import {
  Button,
  Grid,
  Typography,
  Box,
  DialogTitle,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  TableCell,
  TableBody,
  TableHead,
  Paper,
} from '@material-ui/core';
import {LOCATION, LIZ_ACCOUNTING} from "../../../global/Server/endpoints";
import {apiRequest} from "../../../../redux/actions/api";
import InvestorPanel from "./InvestorPanel";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import { startOfMonth, endOfMonth, addDays, format, subDays } from 'date-fns';
import withShipment from "../../../../withShipment";
import FolderCard from "./FolderCard";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import FeedbackBar from "../../../feedbackBar/FeedbackBar";
import AssessmentIcon from '@mui/icons-material/Assessment';
import ProfitSummary from "./profitSummary/ProfitSummary";
import {MONTHS} from "../atm/constant";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from '@material-ui/icons/Visibility';
import RefreshIcon from '@material-ui/icons/Refresh';
import GetAppIcon from '@material-ui/icons/GetApp';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';


class LizAccounting extends React.Component {
  constructor(props) {
    super(props);

    const startYear = 2025;
    const currentYear = new Date().getFullYear();

    const YEARS = [];
    for (let year = startYear; year <= currentYear; year++) {
      YEARS.push(year);
    }

    this.state = {
      YEARS,
      adjustments: [],
      adjustmentForm: { description: '', type: 'ADD', amount: '' },
      showAdjustments: false,
      locations: [],
      weeklyProfits: [],
      allLocationSummary: [],

      ericProfitShares: [],
      ericAdditions: [],
      ericSubtractions: [],

      lizProfitShares: [],
      lizAdditions: [],
      lizSubtractions: [],

      unassignedAdditions: [], // all session additions combined
      unassignedSubtractions: [], // all session deductions combined
      unassignedOthers: [],

      manualDialogOpen: false,
      manualType: 'ADD',
      manualDescription: '',
      manualAmount: '',
      selectedInvestor: null,

      selectedYear: null,
      selectedMonth: null,
      selectedWeek: null, // { weekNumber, fromDate, toDate }

      weeklyData: null, // loaded OR fetched data

      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',

      isProfitSummary: false,
      isEditMode: false,
      isDeliveryView: false,

      ericExtra: { atm: 0, owes: 0 },
      lizCashInHand: 0,

      refreshDialogOpen: false,
      savedEricAdditions: [],
      savedLizAdditions: [],
      savedEricSubtractions: [],
      savedLizSubtractions: [],
    };
  }

  async componentDidMount() {
    await this.fetchLocations();

    const result = this.getLastCompletedAccountingWeek();

    if (!result) return;

    const { year, monthIndex, week } = result;

    this.setState(
      {
        selectedYear: year,
        selectedMonth: monthIndex,
      },
      async () => {
        await this.openWeek(week);
      }
    );
  }

  sumAmounts = (arr = []) =>
    arr.reduce((sum, a) => sum + (Number(a.amount) || 0), 0);

  getEricBaseSubtotal = (ericProfitShares) =>
    ericProfitShares.reduce((s, p) => s + p.amount, 0) +
    this.sumAmounts(this.state.ericAdditions) -
    this.sumAmounts(this.state.ericSubtractions);

  getEricFinalTotals = (ericProfitShares, ericExtra = this.state.ericExtra) => {
    const SAMM = 450;
    const atmFromProfit = Number(ericExtra.atm || 0);
    const owesATM = Number(ericExtra.owes || 0);

    const baseSubtotal = this.getEricBaseSubtotal(ericProfitShares);
    const subTotal = baseSubtotal - SAMM - atmFromProfit;
    const total = subTotal - owesATM;

    return { baseSubtotal, subTotal, total, SAMM };
  };

  generateWeeksForMonth = (year, monthIndex) => {
    const weeks = [];
    let date = startOfMonth(new Date(year, monthIndex));

    // move to first Tuesday (Feb 3 for Feb 2026)
    while (date.getDay() !== 2) {
      date = addDays(date, 1);
    }

    let week = 1;
    while (date <= endOfMonth(new Date(year, monthIndex))) {
      const fromDate = new Date(date); // This remains Feb 3
      const toDate = addDays(fromDate, 6); // This remains Feb 9

      weeks.push({
        weekNumber: week,
        fromDate,
        toDate,
        // We subtract 1 day ONLY for the display label
        label: `Week ${week} (${format(
          addDays(fromDate, -1),
          'MMM d'
        )}–${format(addDays(toDate, -1), 'd')})`,
      });

      week++;
      date = addDays(date, 7);
    }

    return weeks;
  };

  getLastCompletedAccountingWeek = () => {
    const today = new Date();

    // Check current month first
    let year = today.getFullYear();
    let monthIndex = today.getMonth();

    for (let i = 0; i < 12; i++) {
      const weeks = this.generateWeeksForMonth(year, monthIndex);

      const lastWeek = [...weeks].reverse().find((w) => w.toDate < today);

      if (lastWeek) {
        return { year, monthIndex, week: lastWeek };
      }

      // Move to previous month
      monthIndex--;
      if (monthIndex < 0) {
        monthIndex = 11;
        year--;
      }
    }

    return null;
  };

  openWeek = (week) => {
    const { selectedYear, selectedMonth, locations } = this.state;

    this.setState({
      selectedWeek: week,
      fromDate: week.fromDate,
      toDate: week.toDate,
      weeklyProfits: [],
      unassignedAdditions: [],
      unassignedSubtractions: [],
      unassignedOthers: [],
      ericAdditions: [],
      ericSubtractions: [],
      lizAdditions: [],
      lizSubtractions: [],
      ericExtra: { atm: 0, owes: 0 },
      lizCashInHand: 0,
    });

    // 1️⃣ Fetch saved week from backend
    this.props.apiRequest({
      key: 'lizAccounting/getWeek',
      endpoint: LIZ_ACCOUNTING.GET_WEEK,
      data: {
        year: selectedYear,
        month: selectedMonth + 1, // monthIndex 0-11 → 1-12
        weekNumber: week.weekNumber,
      },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success && payload.week) {
          // Week exists in DB → load it
          const weekData = payload.week;

          const lizAdds = weekData.lizAdditions || [];
          if (!lizAdds.some((a) => a.description === 'SAMM')) {
            lizAdds.push({
              description: 'SAMM',
              amount: 450,
              locationName: '',
              isManual: false,
            });
          }
          weekData.lizAdditions = lizAdds;

          this.setState({ ...weekData });
          this.fetchDeliverySummary(week);
          return;
        }

        // 2️⃣ No saved data → fallback to fetch from locations
        if (locations.length) {
          this.applyDateRange();
        }
      },
      onError: (err) =>
        this.openFeedback('error', `Failed to load week data: ${err}`),
    });
  };

  saveWeekData = () => {
    const { selectedYear, selectedMonth, selectedWeek } = this.state;
    if (!selectedWeek) return;

    const payload = {
      year: selectedYear,
      month: selectedMonth + 1, // store as 1-12
      weekNumber: selectedWeek.weekNumber,
      weeklyProfits: this.state.weeklyProfits,
      unassignedAdditions: this.state.unassignedAdditions,
      unassignedSubtractions: this.state.unassignedSubtractions,
      unassignedOthers: this.state.unassignedOthers,
      ericAdditions: this.state.ericAdditions,
      ericSubtractions: this.state.ericSubtractions,
      lizAdditions: this.state.lizAdditions,
      lizSubtractions: this.state.lizSubtractions,
      fromDate: selectedWeek.fromDate,
      toDate: selectedWeek.toDate,
      ericExtra: this.state.ericExtra,
      lizCashInHand: this.state.lizCashInHand,
    };

    this.props.apiRequest({
      key: 'lizAccounting/saveWeek',
      endpoint: LIZ_ACCOUNTING.SAVE_WEEK,
      data: payload,
      silent: true,
      onSuccess: (response) => {
        if (response?.success) {
          this.openFeedback('success', 'Week saved successfully');
          this.setState({ isEditMode: false });
        } else {
          this.openFeedback('error', 'Failed to save week');
        }
      },
      onError: (err) =>
        this.openFeedback('error', `Failed to save week: ${err}`),
    });
  };

  openYear = (year) => {
    this.setState({
      selectedYear: year,
      selectedMonth: null,
      selectedWeek: null,
    });
  };

  openMonth = (monthIndex) => {
    this.setState({
      selectedMonth: monthIndex,
      selectedWeek: null,
    });
  };

  openFeedback = (severity, message) => {
    this.setState({
      feedbackBarOpen: true,
      feedbackStatus: severity,
      feedbackMessage: message,
    });
  };

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false });
  };

  //APIS
  fetchLocations = () => {
    this.props.apiRequest({
      key: 'lizAccounting/locations',
      method: 'GET',
      endpoint: LOCATION.LIST,
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.setState({ locations: payload.locations });
        } else {
          this.openFeedback('error', 'Failed to fetch locations');
        }
      },
      onError: (err) =>
        this.openFeedback('error', `Failed to fetch locations: ${err}`),
    });
  };

  fetchDeliverySummary = (week) => {
    const { locations } = this.state;
    if (!locations.length || !week?.fromDate || !week?.toDate) return;

    const from = format(new Date(week.fromDate), 'yyyy-MM-dd');
    const to = format(new Date(week.toDate), 'yyyy-MM-dd');

    this.props.apiRequest({
      key: 'lizAccounting/deliverySummary',
      endpoint: LIZ_ACCOUNTING.LOCATION_SUMMARY,
      data: {
        fromDate: from,
        toDate: to,
        locations: locations.map((l) => l.name),
      },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success) {
          this.setState({ allLocationSummary: payload.sessions });
        }
      },
      onError: (err) =>
        this.openFeedback('error', `Failed to load delivery data: ${err}`),
    });
  };

  applyDateRange = () => {
    const { selectedWeek, locations } = this.state;
    if (!locations.length) return;

    if (!selectedWeek?.fromDate || !selectedWeek?.toDate) {
      this.openFeedback('error', 'Invalid week date range');
      return;
    }

    const from = format(new Date(selectedWeek.fromDate), 'yyyy-MM-dd');
    const to = format(new Date(selectedWeek.toDate), 'yyyy-MM-dd');

    this.props.apiRequest({
      key: 'lizAccounting/applyDateRange',
      endpoint: LIZ_ACCOUNTING.LOCATION_SUMMARY,
      data: {
        fromDate: from,
        toDate: to,
        locations: locations.map((l) => l.name),
      },
      silent: true,
      onError: (err) =>
        this.openFeedback('error', `Failed to load weekly data: ${err}`),
      onSuccess: (res) => {
        if (!res?.success) {
          this.openFeedback('error', 'Failed to fetch weekly profits');
          return;
        }

        // Temporary buckets for auto-sorting
        const autoEricAdditions = [];
        const autoLizAdditions = [];
        const autoEricSubtractions = [];
        const autoLizSubtractions = [];

        let totalAtmReceipts = 0;
        let totalOwesAmount = 0;
        let totalCashInHand = 0;

        // Remaining unassigned (if assignedTo is missing or doesn't match)
        const allUnassignedAdditions = [];
        const allUnassignedSubtractions = [];
        const allUnassignedOthers = [];

        const weeklyProfits = res.sessions
        .map((session) => {
          const loc = locations.find(
            (l) => l.name.toUpperCase() === session.locationName.toUpperCase()
          );
          if (!loc) return null;

          const mSummary = session.managerSummary || {};
          const managerName = (mSummary.managerName || 'Unknown').trim();

          // --- 1. SUM ATM RECEIPTS (ATM State) ---
          totalAtmReceipts += Number(mSummary.delivery?.atmReceipts || 0);

          totalCashInHand += Number(mSummary.delivery?.cash || 0);

          const sessionDelivery = mSummary.delivery || [];

          if (sessionDelivery) {
            // SPECIAL ZELLE - Access properties directly
            if (sessionDelivery.managerZelle > 0) {
              const autoEntry = {
                description: `Zelle`,
                amount: sessionDelivery.managerZelle,
                locationName: session.locationName,
                isManual: false,
              };

              autoLizSubtractions.push(autoEntry);
            }
          }

          //Atm adv
          if (sessionDelivery) {
            // SPECIAL ATM ADV - Access properties directly
            if (sessionDelivery.atmAdv > 0) {
              const autoEntry = {
                description: `ATM ADV`,
                amount: sessionDelivery.atmAdv,
                locationName: session.locationName,
                isManual: false,
              };

              autoLizSubtractions.push(autoEntry);
            }
          }

          // --- 2. PROCESS ATM TRANSACTIONS (OWES & AUTO-ENTRIES) ---
          const sessionTransactions = mSummary.atmTransactions || [];
          sessionTransactions.forEach((trans) => {
            const amount = Number(trans.amount || 0);

            // Sum for Eric's 'Owes' field
            if (trans.type === 'ATM_ADV' || trans.type === 'ATM_DIDNT_USE') {
              totalOwesAmount += amount;
            }

            // SPECIAL LOGIC: "ATM didn't use" automation
            if (trans.type === 'ATM_DIDNT_USE' && amount > 0) {
              const autoEntry = {
                description: `ATM didn't use (${managerName})`,
                amount: amount,
                locationName: session.locationName,
                isManual: false,
              };
              // Add to Eric Additions and Liz Subtractions
              autoEricAdditions.push(autoEntry);
              autoLizSubtractions.push(autoEntry);
            }
          });

          // --- 3. CALCULATE INVESTOR SHARES ---
          const netProfit = session.managerSummary.weeklyNetProfit || 0;
          const managers = loc.investors.filter((i) => i.isManager === true);
          const owners = loc.investors.filter((i) => !i.isManager);

          let totalManagerShare = 0;
          const managerShares = managers.map((m) => {
            const threshold = Number(m.profitThreshold) || 0;
            const pct = Number(m.percentage) || 0;
            const share = (Math.max(0, netProfit - threshold) * pct) / 100;
            totalManagerShare += share;
            return {
              investorId: m.investorId,
              share: Number(share.toFixed(2)),
            };
          });

          const remainingProfit = Math.max(0, netProfit - totalManagerShare);
          const totalOwnerPct = owners.reduce(
            (sum, o) => sum + (o.percentage || 0),
            0
          );

          const investors = loc.investors.map((inv) => {
            if (inv.isManager === true) {
              return {
                ...inv,
                share:
                  managerShares.find((ms) => ms.investorId === inv.investorId)
                    ?.share || 0,
              };
            }
            const normalizedPct = totalOwnerPct
              ? inv.percentage / totalOwnerPct
              : 0;
            return {
              ...inv,
              share: Number((remainingProfit * normalizedPct).toFixed(2)),
            };
          });

          // --- NEW AUTO-ASSIGN LOGIC START ---

          const processItem = (item, listType) => {
            const enhancedItem = {
              ...item,
              locationName: session.locationName,
            };
            const assigned = item.assignedTo
              ? item.assignedTo.trim().toLowerCase()
              : null;

            if (listType === 'ADD') {
              if (assigned === 'eric') autoEricAdditions.push(enhancedItem);
              else if (assigned === 'liz') autoLizAdditions.push(enhancedItem);
              else allUnassignedAdditions.push(enhancedItem);
            } else if (listType === 'SUB') {
              if (assigned === 'eric') autoEricSubtractions.push(enhancedItem);
              else if (assigned === 'liz')
                autoLizSubtractions.push(enhancedItem);
              else allUnassignedSubtractions.push(enhancedItem);
            } else {
              // Others (ATM/Adv) - Typically go to Subtractions if assigned
              if (assigned === 'eric') autoEricSubtractions.push(enhancedItem);
              else if (assigned === 'liz')
                autoLizSubtractions.push(enhancedItem);
              else allUnassignedOthers.push(enhancedItem);
            }
          };

          (session.managerSummary.adjustments.additions || []).forEach((a) =>
            processItem(a, 'ADD')
          );
          (session.managerSummary.adjustments.deductions || []).forEach((d) =>
            processItem(d, 'SUB')
          );
          (session.managerSummary.otherItems || []).forEach((o) =>
            processItem(o, 'OTHER')
          );

          // --- NEW AUTO-ASSIGN LOGIC END ---

          return {
            id: session.readingSessionId,
            locationId: loc.locationId,
            locationName: session.locationName,
            date: new Date(from),
            netProfit,
            investors,
          };
        })
        .filter(Boolean);

      const hasSAMM = autoLizAdditions.some((a) => a.description === 'SAMM');
      if (!hasSAMM) {
        autoLizAdditions.push({
          description: 'SAMM',
          amount: 450,
          locationName: '',
          isManual: false,
        });
      }

        this.setState((prevState) => ({
          weeklyProfits,
          unassignedAdditions: allUnassignedAdditions,
          unassignedSubtractions: allUnassignedSubtractions,
          unassignedOthers: allUnassignedOthers,
          allLocationSummary: res.sessions,
          ericAdditions: autoEricAdditions,
          lizAdditions: autoLizAdditions,
          ericSubtractions: autoEricSubtractions,
          lizSubtractions: autoLizSubtractions,
          lizCashInHand: totalCashInHand,
          ericExtra: {
            ...prevState.ericExtra,
            atm: totalAtmReceipts,
            owes: totalOwesAmount,
          },
        }));
      },
    });
  };

  //end of apis

  openManualDialog = (type, investor) => {
    this.setState({
      manualDialogOpen: true,
      manualType: type,
      manualDescription: '',
      manualAmount: '',
      selectedInvestor: investor,
    });
  };

  closeManualDialog = () => {
    this.setState({ manualDialogOpen: false });
  };

  saveManualEntry = () => {
    const { manualType, manualDescription, manualAmount, selectedInvestor } =
      this.state;

    if (!manualDescription || !manualAmount) return;
    if (!selectedInvestor) return; // no investor selected → do nothing

    const entry = {
      description: manualDescription,
      amount: Number(manualAmount),
      locationName: '',
      isManual: true,
    };

    if (manualType === 'ADD') {
      this.setState((prev) => ({
        [`${selectedInvestor.toLowerCase()}Additions`]: [
          ...prev[`${selectedInvestor.toLowerCase()}Additions`],
          entry,
        ],
      }));
    } else {
      this.setState((prev) => ({
        [`${selectedInvestor.toLowerCase()}Subtractions`]: [
          ...prev[`${selectedInvestor.toLowerCase()}Subtractions`],
          entry,
        ],
      }));
    }

    this.closeManualDialog();
  };

  removeManualEntry = (investor, type, originalIndex) => {
    const key =
      type === 'ADD'
        ? `${investor.toLowerCase()}Additions`
        : `${investor.toLowerCase()}Subtractions`;

    this.setState((prev) => ({
      [key]: prev[key].filter((_, i) => i !== originalIndex),
    }));
  };

  // Move item to unassigned list (Eric/Liz → Unassigned)
  unassignItem = (investor, type, originalIndex) => {
    const key =
      type === 'ADD'
        ? `${investor.toLowerCase()}Additions`
        : `${investor.toLowerCase()}Subtractions`;

    const unassignedKey =
      type === 'ADD' ? 'unassignedAdditions' : 'unassignedSubtractions';

    this.setState((prev) => {
      const item = prev[key][originalIndex];
      const updatedList = prev[key].filter((_, i) => i !== originalIndex);

      return {
        [key]: updatedList,
        [unassignedKey]: [
          ...prev[unassignedKey],
          { ...item, fromInvestor: investor, type },
        ],
      };
    });
  };

  handleDragEnd = (result) => {
    const { source, destination } = result;

    const getList = (id) => {
      switch (id) {
        case 'unassigned-additions':
          return [...this.state.unassignedAdditions];
        case 'unassigned-subtractions':
          return [...this.state.unassignedSubtractions];
        case 'unassigned-others':
          return [...this.state.unassignedOthers];
        case 'Eric-additions':
          return [...this.state.ericAdditions];
        case 'Liz-additions':
          return [...this.state.lizAdditions];
        case 'Eric-subtractions':
          return [...this.state.ericSubtractions];
        case 'Liz-subtractions':
          return [...this.state.lizSubtractions];
        default:
          return [];
      }
    };

    const setList = (id, list) => {
      switch (id) {
        case 'unassigned-additions':
          this.setState({ unassignedAdditions: list });
          break;
        case 'unassigned-subtractions':
          this.setState({ unassignedSubtractions: list });
          break;
        case 'unassigned-others':
          this.setState({ unassignedOthers: list });
          break;
        case 'Eric-additions':
          this.setState({ ericAdditions: list });
          break;
        case 'Liz-additions':
          this.setState({ lizAdditions: list });
          break;
        case 'Eric-subtractions':
          this.setState({ ericSubtractions: list });
          break;
        case 'Liz-subtractions':
          this.setState({ lizSubtractions: list });
          break;
        default:
          break;
      }
    };

    if (!destination) {
      const sourceId = source.droppableId;

      // already unassigned → nothing to do
      if (sourceId.startsWith('unassigned')) return;

      let targetId = 'unassigned-others';

      if (sourceId.includes('additions')) {
        targetId = 'unassigned-additions';
      } else if (sourceId.includes('subtractions')) {
        targetId = 'unassigned-subtractions';
      }

      const sourceList = getList(sourceId);
      const targetList = getList(targetId);

      const [movedItem] = sourceList.splice(source.index, 1);
      targetList.push(movedItem);

      setList(sourceId, sourceList);
      setList(targetId, targetList);
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const list = getList(source.droppableId);
      const [movedItem] = list.splice(source.index, 1);
      list.splice(destination.index, 0, movedItem);
      setList(source.droppableId, list);
      return;
    }

    const sourceList = getList(source.droppableId);
    const destList = getList(destination.droppableId);

    const [movedItem] = sourceList.splice(source.index, 1);
    destList.splice(destination.index, 0, movedItem);

    setList(source.droppableId, sourceList);
    setList(destination.droppableId, destList);
  };

  assignToInvestor = (item, investorName, type) => {
    if (type === 'ADD') {
      this.setState((prev) => ({
        unassignedAdditions: prev.unassignedAdditions.filter((i) => i !== item),
        [`${investorName.toLowerCase()}Additions`]: [
          ...prev[`${investorName.toLowerCase()}Additions`],
          item,
        ],
      }));
    } else if (type === 'SUB') {
      this.setState((prev) => ({
        unassignedSubtractions: prev.unassignedSubtractions.filter(
          (i) => i !== item
        ),
        [`${investorName.toLowerCase()}Subtractions`]: [
          ...prev[`${investorName.toLowerCase()}Subtractions`],
          item,
        ],
      }));
    } else if (type === 'OTHER') {
      this.setState((prev) => ({
        unassignedOthers: prev.unassignedOthers.filter((i) => i !== item),
        [`${investorName.toLowerCase()}Subtractions`]: [
          ...prev[`${investorName.toLowerCase()}Subtractions`],
          item,
        ],
      }));
    }
  };

  renderViewMode = (ericProfitShares, lizProfitShares) => {
    return (
      <Grid
        container
        spacing={3}
        wrap="nowrap"
        style={{
          overflowX: 'auto',
        }}
        className="mobile-slider"
      >
        <DragDropContext onDragEnd={this.handleDragEnd}>
          <Grid item xs={12} md={6} className="slider-item">
            <InvestorPanel
              investor="Eric"
              profitShares={ericProfitShares}
              additions={this.state.ericAdditions}
              subtractions={this.state.ericSubtractions}
              onDragEnd={this.handleDragEnd}
              openManualDialog={this.openManualDialog}
              onRemoveManual={this.removeManualEntry}
              ericExtra={this.state.ericExtra}
              updateEricExtra={(newExtra) => {
                this.setState({ ericExtra: newExtra }, () => {
                  // Recalculate Eric subtotal
                  const ericSubtotal = this.getEricFinalTotals(
                    this.state.ericProfitShares,
                    newExtra
                  ).subTotal;
                  this.setState({ ericSubtotal });
                });
              }}
              // updateEricExtra={(newExtra) => this.setState({ ericExtra: newExtra })}
              updateLizExtra={(cashInHand) =>
                this.setState({ lizCashInHand: cashInHand })
              }
            />
          </Grid>
          <Grid item xs={12} md={6} className="slider-item">
            <InvestorPanel
              investor="Liz"
              profitShares={lizProfitShares}
              additions={this.state.lizAdditions}
              subtractions={this.state.lizSubtractions}
              onDragEnd={this.handleDragEnd}
              openManualDialog={this.openManualDialog}
              onRemoveManual={this.removeManualEntry}
              isEditMode={this.state.isEditMode}
              ericExtra={this.state.ericExtra} // so Liz panel sees latest Eric extra
              lizCashInHand={this.state.lizCashInHand}
              updateLizExtra={(cashInHand) =>
                this.setState({ lizCashInHand: cashInHand })
              }
              ericSubtotal={this.getEricFinalTotals(ericProfitShares).subTotal}
            />
          </Grid>
        </DragDropContext>
      </Grid>
    );
  };

  // ─── DELIVERY VIEW HELPERS ───────────────────────────────────────────────────

  getDeliveryRows = () => {
    const { allLocationSummary } = this.state;
    if (!allLocationSummary || !allLocationSummary.length) return [];

    return allLocationSummary.map((session) => {
      const delivery = session.managerSummary?.delivery || {};
      return {
        locationName: session.locationName,
        cash: Number(delivery.cash || 0),
        zelle: Number(delivery.managerZelle || 0),
        atmReceipts: Number(delivery.atmReceipts || 0),
        atmAdv: Number(delivery.atmAdv || 0),
        totalDelivered: Number(delivery.totalDelivered || 0),
      };
    });
  };

  downloadDeliveryPDF = () => {
    const { selectedWeek } = this.state;
    const rows = this.getDeliveryRows();

    const doc = new jsPDF();

    // Title
    const weekLabel = selectedWeek
      ? `Week of ${format(
          subDays(new Date(selectedWeek.fromDate), 1),
          'MMM d, yyyy'
        )}`
      : 'Delivery Summary';

    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.text('How It Was Delivered', 14, 20);

    doc.setFontSize(11);
    doc.setTextColor(100, 100, 100);
    doc.text(weekLabel, 14, 28);

    // Totals
    const totals = rows.reduce(
      (acc, r) => ({
        cash: acc.cash + r.cash,
        zelle: acc.zelle + r.zelle,
        atmReceipts: acc.atmReceipts + r.atmReceipts,
        atmAdv: acc.atmAdv + r.atmAdv,
        totalDelivered: acc.totalDelivered + r.totalDelivered,
      }),
      { cash: 0, zelle: 0, atmReceipts: 0, atmAdv: 0, totalDelivered: 0 }
    );

    const fmt = (val) =>
      `$${Number(val).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

    autoTable(doc, {
      startY: 35,
      head: [
        [
          'Location',
          'Cash',
          'Zelle',
          'ATM Receipts',
          'ATM Adv',
          'Total Delivered',
        ],
      ],
      body: [
        ...rows.map((r) => [
          r.locationName,
          fmt(r.cash),
          fmt(r.zelle),
          fmt(r.atmReceipts),
          fmt(r.atmAdv),
          fmt(r.totalDelivered),
        ]),
        // Totals row
        [
          { content: 'TOTAL', styles: { fontStyle: 'bold' } },
          { content: fmt(totals.cash), styles: { fontStyle: 'bold' } },
          { content: fmt(totals.zelle), styles: { fontStyle: 'bold' } },
          { content: fmt(totals.atmReceipts), styles: { fontStyle: 'bold' } },
          { content: fmt(totals.atmAdv), styles: { fontStyle: 'bold' } },
          {
            content: fmt(totals.totalDelivered),
            styles: { fontStyle: 'bold' },
          },
        ],
      ],
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10,
      },
      bodyStyles: {
        fontSize: 10,
        textColor: [40, 40, 40],
      },
      alternateRowStyles: {
        fillColor: [245, 247, 255],
      },
      styles: {
        cellPadding: 5,
        lineColor: [200, 200, 220],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 40 },
      },
    });

    const fileName = selectedWeek
      ? `delivery_${format(
          subDays(new Date(selectedWeek.fromDate), 1),
          'yyyy-MM-dd'
        )}.pdf`
      : 'delivery_summary.pdf';

    doc.save(fileName);
  };

  renderDeliveryView = () => {
    const rows = this.getDeliveryRows();

    const totals = rows.reduce(
      (acc, r) => ({
        cash: acc.cash + r.cash,
        zelle: acc.zelle + r.zelle,
        atmReceipts: acc.atmReceipts + r.atmReceipts,
        atmAdv: acc.atmAdv + r.atmAdv,
        totalDelivered: acc.totalDelivered + r.totalDelivered,
      }),
      { cash: 0, zelle: 0, atmReceipts: 0, atmAdv: 0, totalDelivered: 0 }
    );

    const fmt = (val) =>
      `$${Number(val).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

    return (
      <div style={{ padding: '8px 0' }}>
        {/* Download button */}
        <Box
          display="flex"
          justifyContent="flex-end"
          style={{ marginBottom: 16 }}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<GetAppIcon />}
            onClick={this.downloadDeliveryPDF}
            style={{
              borderRadius: 8,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(63,81,181,0.3)',
            }}
          >
            Download PDF
          </Button>
        </Box>

        {/* Summary Cards — mobile-friendly totals strip */}
        <Grid container spacing={2} style={{ marginBottom: 20 }}>
          {[
            {
              label: 'Total Cash',
              value: fmt(totals.cash),
              color: '#43a047',
              fontFamily: "'Inter', 'Roboto', sans-serif",
            },
            {
              label: 'Total Zelle',
              value: fmt(totals.zelle),
              color: '#1e88e5',
              fontFamily: "'Inter', 'Roboto', sans-serif",
            },
            {
              label: 'ATM Receipts',
              value: fmt(totals.atmReceipts),
              color: '#8e24aa',
              fontFamily: "'Inter', 'Roboto', sans-serif",
            },
            {
              label: 'ATM Adv',
              value: fmt(totals.atmAdv),
              color: '#e53935',
              fontFamily: "'Inter', 'Roboto', sans-serif",
            },
            {
              label: 'Total Delivered',
              value: fmt(totals.totalDelivered),
              color: '#3f51b5',
              fontFamily: "'Inter', 'Roboto', sans-serif",
            },
          ].map((card) => (
            <Grid item xs={6} sm={4} md={2} key={card.label}>
              <Paper
                elevation={2}
                style={{
                  padding: '12px 10px',
                  borderRadius: 10,
                  borderTop: `4px solid ${card.color}`,
                  textAlign: 'center',
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                }}
              >
                <Typography
                  variant="caption"
                  style={{
                    color: '#888',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: 4,
                    fontFamily: "'Inter', 'Roboto', sans-serif",
                  }}
                >
                  {card.label}
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: 700,
                    color: card.color,
                    fontSize: '1rem',
                    fontFamily: "'Inter', 'Roboto', sans-serif",
                  }}
                >
                  {card.value}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Table */}
        <TableContainer
          component={Paper}
          elevation={2}
          style={{ borderRadius: 12, overflowX: 'auto' }}
        >
          <Table size="small" style={{ minWidth: 520 }}>
            <TableHead>
              <TableRow style={{ backgroundColor: '#3f51b5' }}>
                {[
                  'Location',
                  'Cash',
                  'Zelle',
                  'ATM Receipts',
                  'ATM Adv',
                  'Total Delivered',
                ].map((col) => (
                  <TableCell
                    key={col}
                    align={col === 'Location' ? 'left' : 'right'}
                    style={{
                      color: '#000',
                      fontWeight: 700,
                      fontSize: 13,
                      padding: '12px 16px',
                      whiteSpace: 'nowrap',
                      fontFamily: "'Inter', 'Roboto', sans-serif",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    style={{ padding: 32, color: '#999' }}
                  >
                    No delivery data available for this week.
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {rows.map((row, idx) => (
                    <TableRow
                      key={row.locationName}
                      style={{
                        backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f7ff',
                      }}
                    >
                      <TableCell
                        style={{
                          fontWeight: 700,
                          color: '#333',
                          padding: '10px 16px',
                          fontFamily: "'Inter', 'Roboto', sans-serif",
                        }}
                      >
                        {row.locationName}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          padding: '10px 16px',
                          color: row.cash > 0 ? '#43a047' : 'gray',
                          fontFamily: "'Inter', 'Roboto', sans-serif",
                        }}
                      >
                        {fmt(row.cash)}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          padding: '10px 16px',
                          color: row.zelle > 0 ? '#1e88e5' : 'gray',
                        }}
                      >
                        {fmt(row.zelle)}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          padding: '10px 16px',
                          color: row.atmReceipts > 0 ? '#8e24aa' : 'gray',
                          fontFamily: "'Inter', 'Roboto', sans-serif",
                        }}
                      >
                        {fmt(row.atmReceipts)}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          padding: '10px 16px',
                          color: row.atmAdv > 0 ? '#e53935' : 'gray',
                        }}
                      >
                        {fmt(row.atmAdv)}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          padding: '10px 16px',
                          fontWeight: 700,
                          color: '#3f51b5',
                        }}
                      >
                        {fmt(row.totalDelivered)}
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Totals Row */}
                  <TableRow style={{ backgroundColor: '#e8eaf6' }}>
                    <TableCell
                      style={{
                        fontWeight: 800,
                        fontSize: 13,
                        padding: '12px 16px',
                        color: 'black',
                        borderTop: '2px solid gray',
                        fontFamily: "'Inter', 'Roboto', sans-serif",
                      }}
                    >
                      TOTAL
                    </TableCell>
                    {[
                      totals.cash,
                      totals.zelle,
                      totals.atmReceipts,
                      totals.atmAdv,
                      totals.totalDelivered,
                    ].map((val, i) => (
                      <TableCell
                        key={i}
                        align="right"
                        style={{
                          fontWeight: 800,
                          fontSize: 13,
                          padding: '12px 16px',
                          color: 'black',
                          borderTop: '2px solid gray',
                          fontFamily: "'Inter', 'Roboto', sans-serif",
                        }}
                      >
                        {fmt(val)}
                      </TableCell>
                    ))}
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  render() {
    const { weeklyProfits, isDeliveryView } = this.state;

    const lizProfitShares = (weeklyProfits || []).map((w) => {
      const inv = w.investors?.find((i) => i.name === 'Liz');
      return { location: w.locationName, amount: inv?.share ?? 0 };
    });

    const ericProfitShares = (weeklyProfits || []).map((w) => {
      const inv = w.investors?.find((i) => i.name === 'Eric');
      return { location: w.locationName, amount: inv?.share ?? 0 };
    });

    let headerButtons = [];

    if (isDeliveryView) {
      // When in delivery view → only show Back
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        title: 'Back',
        handler: () => {
          this.setState({ isDeliveryView: false });
        },
      });
    } else if (
      this.state.selectedWeek ||
      this.state.selectedMonth !== null ||
      this.state.selectedYear !== null
    ) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        title: 'Back',
        handler: () => {
          if (this.state.selectedWeek) {
            this.setState({ selectedWeek: null, isEditMode: false });
          } else if (this.state.selectedMonth !== null) {
            this.setState({ selectedMonth: null, isEditMode: false });
          } else if (this.state.selectedYear !== null) {
            this.setState({ selectedYear: null, isEditMode: false });
          }
        },
      });
    } else {
      if (!this.state.isProfitSummary) {
        headerButtons.push({
          icon: <AssessmentIcon />,
          title: 'Profit Summary',
          handler: () => {
            this.setState({ isProfitSummary: true });
          },
        });
      } else {
        headerButtons.push({
          icon: <KeyboardBackspaceIcon />,
          title: 'Back',
          handler: () => {
            this.setState({ isProfitSummary: false });
          },
        });
      }
    }

    if (
      this.state.selectedWeek &&
      !this.state.isProfitSummary &&
      !isDeliveryView
    ) {
      headerButtons.push({
        icon: <RefreshIcon />,
        title: 'Refresh',
        handler: async () => {
          // Save manual entries before refresh
          this.setState((prev) => ({
            savedEricAdditions: prev.ericAdditions.filter((i) => i.isManual),
            savedLizAdditions: prev.lizAdditions.filter((i) => i.isManual),
            savedEricSubtractions: prev.ericSubtractions.filter(
              (i) => i.isManual
            ),
            savedLizSubtractions: prev.lizSubtractions.filter(
              (i) => i.isManual
            ),
            refreshDialogOpen: true,
          }));
        },
      });

      headerButtons.push({
        icon: this.state.isEditMode ? <VisibilityIcon /> : <EditIcon />,
        title: this.state.isEditMode ? 'Done Editing' : 'Edit',
        handler: () => {
          this.setState((prev) => ({ isEditMode: !prev.isEditMode }));
        },
      });

      // ── NEW: How Was Delivery button ──
      headerButtons.push({
        icon: (
          <DeliveryIcon
            style={{
              width: '36px',
              height: '36px',
              marginTop: '-7px',
              marginLeft: '-4px',
              color: '#212529',
            }}
          />
        ),
        title: 'Show Delivery Report',
        handler: () => {
          this.setState({ isDeliveryView: true });
        },
      });
    }

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
          handleClose={this.closeFeedbackBar}
        />
        <CustomToolbar
          title={
            this.state.isProfitSummary
              ? 'Profit Summary'
              : this.state.selectedWeek
              ? `Week of ${format(
                  subDays(this.state.selectedWeek.fromDate, 1),
                  'MMM d, yyyy'
                )}`
              : this.state.selectedMonth !== null
              ? `${MONTHS[this.state.selectedMonth]} ${this.state.selectedYear}`
              : this.state.selectedYear !== null
              ? `Year ${this.state.selectedYear}`
              : 'Liz Accounting'
          }
          headerButtons={headerButtons}
        />

        <div className="root">
          {isDeliveryView ? (
            this.renderDeliveryView()
          ) : this.state.isProfitSummary ? (
            <ProfitSummary />
          ) : (
            <>
              {!this.state.selectedYear && (
                <Grid container spacing={4}>
                  {this.state.YEARS.map((year) => (
                    <Grid item xs={12} sm={6} md={3} key={year}>
                      <FolderCard
                        title={year}
                        subtitle="Accounting Year"
                        variant="year"
                        onClick={() => this.openYear(year)}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}

              {this.state.selectedYear !== null &&
                this.state.selectedMonth === null && (
                  <Grid container spacing={3}>
                    {MONTHS.map((month, idx) => (
                      <Grid item xs={12} sm={6} md={3} key={month}>
                        <FolderCard
                          title={month}
                          subtitle="Accounting Month"
                          variant="month"
                          onClick={() => this.openMonth(idx)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}

              {this.state.selectedYear !== null &&
                this.state.selectedMonth !== null &&
                !this.state.selectedWeek && (
                  <Grid container spacing={3}>
                    {this.generateWeeksForMonth(
                      this.state.selectedYear,
                      this.state.selectedMonth
                    ).map((week) => (
                      <Grid item xs={12} sm={6} md={4} key={week.weekNumber}>
                        <FolderCard
                          title={week.label}
                          subtitle="Accounting Week"
                          variant="week"
                          onClick={() => this.openWeek(week)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}
            </>
          )}

          <Dialog
            open={this.state.refreshDialogOpen}
            onClose={() => this.setState({ refreshDialogOpen: false })}
          >
            <DialogTitle>Refresh Week Data?</DialogTitle>
            <DialogContent>
              <Typography>
                This will fetch the latest updates from the location summary.
                Any unsaved manual changes will be lost.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ refreshDialogOpen: false })}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={async () => {
                  this.setState({ refreshDialogOpen: false });
                  await this.applyDateRange(); // fetch latest locationSummary

                  // Restore manual entries
                  this.setState(
                    (prev) => ({
                      ericAdditions: [
                        ...prev.ericAdditions,
                        ...prev.savedEricAdditions,
                      ],
                      lizAdditions: [
                        ...prev.lizAdditions,
                        ...prev.savedLizAdditions,
                      ],
                      ericSubtractions: [
                        ...prev.ericSubtractions,
                        ...prev.savedEricSubtractions,
                      ],
                      lizSubtractions: [
                        ...prev.lizSubtractions,
                        ...prev.savedLizSubtractions,
                      ],

                      // Clear saved manual entries
                      savedEricAdditions: [],
                      savedLizAdditions: [],
                      savedEricSubtractions: [],
                      savedLizSubtractions: [],
                    }),
                    () => {
                      this.saveWeekData();
                    }
                  );

                  this.openFeedback('success', 'Week data refreshed!');
                }}
              >
                Refresh
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.manualDialogOpen}
            onClose={this.closeManualDialog}
          >
            <DialogTitle>
              {this.state.manualType === 'ADD' && 'Add Manual Addition'}
              {this.state.manualType === 'SUB' && 'Add Manual Subtraction'}
              {this.state.manualType === 'OTHER' && 'Add Manual Removal'}
            </DialogTitle>

            <DialogContent>
              <TextField
                fullWidth
                variant="outlined"
                label="Description"
                value={this.state.manualDescription}
                onChange={(e) =>
                  this.setState({ manualDescription: e.target.value })
                }
                style={{ marginBottom: 16 }}
              />
              <TextField
                variant="outlined"
                fullWidth
                type="number"
                label="Amount"
                value={this.state.manualAmount}
                onChange={(e) =>
                  this.setState({ manualAmount: e.target.value })
                }
              />
            </DialogContent>

            <DialogActions style={{ margin: '16px' }}>
              <Button onClick={this.closeManualDialog}>Cancel</Button>
              <Button
                color="primary"
                variant="contained"
                onClick={this.saveManualEntry}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>

          {!isDeliveryView &&
            this.state.selectedWeek &&
            this.state.weeklyProfits?.length > 0 && (
              <div>
                {this.state.isEditMode ? (
                  <DragDropContext onDragEnd={this.handleDragEnd}>
                    {/* Unassigned Additions */}
                    <Droppable droppableId="unassigned-additions">
                      {(provided) => (
                        <Box
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="section-box add-box"
                        >
                          <Typography
                            variant="h6"
                            style={{ fontWeight: 600, marginBottom: 12 }}
                          >
                            Unassigned Additions
                          </Typography>
                          <div className="unassigned-container">
                            {this.state.unassignedAdditions.map(
                              (item, index) => (
                                <Draggable
                                  key={`unassigned-add-${index}`}
                                  draggableId={`unassigned-add-${index}`}
                                  index={index}
                                >
                                  {(dragProvided) => (
                                    <Box
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                      className="unassigned-card"
                                      style={dragProvided.draggableProps.style}
                                    >
                                      <Typography>
                                        {item.description} ({item.locationName})
                                      </Typography>
                                      <Typography>
                                        ${item.amount.toLocaleString()}
                                      </Typography>

                                      <div className="unassigned-card-actions">
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="primary"
                                          onClick={() =>
                                            this.assignToInvestor(
                                              item,
                                              'Eric',
                                              'ADD'
                                            )
                                          }
                                        >
                                          E
                                        </Button>
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="secondary"
                                          onClick={() =>
                                            this.assignToInvestor(
                                              item,
                                              'Liz',
                                              'ADD'
                                            )
                                          }
                                        >
                                          L
                                        </Button>
                                      </div>
                                    </Box>
                                  )}
                                </Draggable>
                              )
                            )}
                          </div>

                          {provided.placeholder}
                        </Box>
                      )}
                    </Droppable>

                    {/* Unassigned Subtractions */}
                    <Droppable droppableId="unassigned-subtractions">
                      {(provided) => (
                        <Box
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="section-box add-box"
                        >
                          <Typography
                            variant="h6"
                            style={{ fontWeight: 600, marginBottom: 12 }}
                          >
                            Unassigned Subtractions
                          </Typography>

                          <div className="unassigned-container">
                            {this.state.unassignedSubtractions.map(
                              (item, index) => (
                                <Draggable
                                  key={`unassigned-sub-${index}`}
                                  draggableId={`unassigned-sub-${index}`}
                                  index={index}
                                >
                                  {(dragProvided) => (
                                    <Box
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                      className="unassigned-card"
                                      style={dragProvided.draggableProps.style}
                                    >
                                      <Typography>
                                        {item.description} ({item.locationName})
                                      </Typography>
                                      <Typography>
                                        ${item.amount.toLocaleString()}
                                      </Typography>

                                      <div className="unassigned-card-actions">
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="primary"
                                          onClick={() =>
                                            this.assignToInvestor(
                                              item,
                                              'Eric',
                                              'SUB'
                                            )
                                          }
                                        >
                                          E
                                        </Button>
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="secondary"
                                          onClick={() =>
                                            this.assignToInvestor(
                                              item,
                                              'Liz',
                                              'SUB'
                                            )
                                          }
                                        >
                                          L
                                        </Button>
                                      </div>
                                    </Box>
                                  )}
                                </Draggable>
                              )
                            )}
                          </div>
                          {provided.placeholder}
                        </Box>
                      )}
                    </Droppable>

                    {/* Unassigned Others */}
                    <Droppable droppableId="unassigned-others">
                      {(provided) => (
                        <Box
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="section-box add-box"
                        >
                          <Typography
                            variant="h6"
                            style={{ fontWeight: 600, marginBottom: 12 }}
                          >
                            Unassigned Others
                          </Typography>
                          <div className="unassigned-container">
                            {this.state.unassignedOthers.map((item, index) => (
                              <Draggable
                                key={`unassigned-other-${index}`}
                                draggableId={`unassigned-other-${index}`}
                                index={index}
                              >
                                {(dragProvided) => (
                                  <Box
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    {...dragProvided.dragHandleProps}
                                    className="unassigned-card"
                                    style={dragProvided.draggableProps.style}
                                  >
                                    <Typography>
                                      {item.description} ({item.locationName})
                                    </Typography>
                                    <Typography>
                                      ${item.amount.toLocaleString()}
                                    </Typography>

                                    <div className="unassigned-card-actions">
                                      <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                          this.assignToInvestor(
                                            item,
                                            'Eric',
                                            'OTHER'
                                          )
                                        }
                                      >
                                        E
                                      </Button>
                                      <Button
                                        size="small"
                                        variant="contained"
                                        color="secondary"
                                        onClick={() =>
                                          this.assignToInvestor(
                                            item,
                                            'Liz',
                                            'OTHER'
                                          )
                                        }
                                      >
                                        L
                                      </Button>
                                    </div>
                                  </Box>
                                )}
                              </Draggable>
                            ))}
                          </div>
                          {provided.placeholder}
                        </Box>
                      )}
                    </Droppable>

                    {/* Investor Panels */}
                    <Grid
                      container
                      spacing={3}
                      wrap="nowrap"
                      style={{
                        overflowX: 'auto',
                      }}
                      className="mobile-slider"
                    >
                      <Grid item xs={12} md={6} className="slider-item">
                        <InvestorPanel
                          investor="Eric"
                          profitShares={ericProfitShares}
                          additions={this.state.ericAdditions}
                          subtractions={this.state.ericSubtractions}
                          onDragEnd={this.handleDragEnd}
                          openManualDialog={this.openManualDialog}
                          onRemoveManual={this.removeManualEntry}
                          isEditMode={this.state.isEditMode}
                          ericExtra={this.state.ericExtra}
                          updateEricExtra={(newExtra) => {
                            this.setState({ ericExtra: newExtra }, () => {
                              // Recalculate Eric subtotal
                              const ericSubtotal = this.getEricFinalTotals(
                                this.state.ericProfitShares,
                                newExtra
                              ).subTotal;
                              this.setState({ ericSubtotal });
                            });
                          }}
                          updateLizExtra={(cashInHand) =>
                            this.setState({ lizCashInHand: cashInHand })
                          }
                          onUnassignItem={this.unassignItem}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} className="slider-item">
                        <InvestorPanel
                          investor="Liz"
                          profitShares={lizProfitShares}
                          additions={this.state.lizAdditions}
                          subtractions={this.state.lizSubtractions}
                          onDragEnd={this.handleDragEnd}
                          openManualDialog={this.openManualDialog}
                          onRemoveManual={this.removeManualEntry}
                          isEditMode={this.state.isEditMode}
                          ericExtra={this.state.ericExtra} // so Liz panel sees latest Eric extra
                          lizCashInHand={this.state.lizCashInHand}
                          updateLizExtra={(cashInHand) =>
                            this.setState({ lizCashInHand: cashInHand })
                          }
                          ericSubtotal={
                            this.getEricFinalTotals(ericProfitShares).subTotal
                          }
                          onUnassignItem={this.unassignItem}
                        />
                      </Grid>
                    </Grid>
                  </DragDropContext>
                ) : (
                  this.renderViewMode(ericProfitShares, lizProfitShares)
                )}

                {this.state.isEditMode &&
                  this.state.selectedWeek &&
                  this.state.weeklyProfits?.length > 0 && (
                    <div className="action-bar">
                      <Button
                        variant="outlined"
                        onClick={() =>
                          this.setState({
                            selectedWeek: null,
                            isEditMode: false,
                          })
                        }
                        className="action-btn cancel-btn"
                      >
                        Cancel
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.saveWeekData}
                        className="action-btn save-btn"
                      >
                        Save
                      </Button>
                    </div>
                  )}
              </div>
            )}
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({userInfo: userInfoSelector(state)});


export default withShipment({
  mapStateToProps,
  actionCreators: { apiRequest },
}, LizAccounting);
